import Vue from 'vue'

function create (campaignId, data = {}) {
  const path = `/campaigns/${campaignId}/renewals`
  return Vue.api.post(path, { data })
}

export default {
  create
}
